import PersonalCenterShare from './personalCenterShare/PersonalCenterShare'
import PersonalCenterShareTab from './personalCenterShare/PersonalCenterShareTab'

export default {
	Share: PersonalCenterShare,
	Tab: PersonalCenterShareTab
}